<!-- Compiled at 2026-09-18T12:45:23.821Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Orders-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]=""
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="top-right"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="top-right"
								data-defined-in="Orders.CustomerRequestProcess"
							></div>
						</ng-container>
					</ng-template>

					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="content"
								data-defined-in="Orders.CustomerRequestProcess"
							>
								<ng-container
									*lowgileForm="'form33'; preventNavigation: true; let $formDirective; let form = form"
								>
									<ng-container *ngIf="screen.request"
										><div
											class="layout-block vertical"
											[style.align-items]="'inherit'"
											[style.gap]="'1em'"
										>
											<Orders-CustomerRequestInclude
												[$formDirective]="$formDirective"
												[$disabled]="$disabled"
												[$ignoreValidations]="$ignoreValidations"
												[request]="screen.request"
												[setVendorSelection]="true"
											>
											</Orders-CustomerRequestInclude>
											<div
												class="layout-block"
												[style.align-items]="'inherit'"
												[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
												[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
												[style.gap]="'1em'"
											>
												<ng-container
													*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!(form.invalid || (!screen.request.vendorRequestHtmls?.de && !screen.request.vendorRequestHtmls?.en))) as $disabled"
												>
													<button
														mat-raised-button
														class="has-click-handler"
														color="primary"
														(click)="handler_ButtonBlock_25_click_$adhoc_0($event, { form, $disabled: $disabled })"
														[disabled]="$disabled"
													>
														<mat-icon>{{'send'}}</mat-icon
														><span
															[innerHtml]="'Request offers from vendors' | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</button>
												</ng-container>
												<span
													[innerHtml]="'' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
												<button
													mat-raised-button
													class="has-click-handler"
													color="warn"
													(click)="handler_ButtonBlock_30_click_$adhoc_0($event, { form, $disabled: $disabled })"
													[disabled]="$disabled"
												>
													<mat-icon>{{'send'}}</mat-icon
													><span
														[innerHtml]="'Manually close request' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</button>
												<button
													mat-raised-button
													class="has-click-handler"
													color="warn"
													(click)="handler_ButtonBlock_31_click_$adhoc_0($event, { form, $disabled: $disabled })"
													[disabled]="$disabled"
												>
													<mat-icon>{{'send'}}</mat-icon
													><span
														[innerHtml]="'Delete request' | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</button>
											</div></div
									></ng-container>
								</ng-container>
							</div>
						</ng-container>
					</ng-template>
				</Orders-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
